import React from 'react';

import { Paper } from '@mui/material';

interface Props {
  children: React.ReactNode;
}

export default function ReportCard({ children }: Props) {
  return (
    <Paper variant="outlined" sx={{ overflow: 'hidden', borderRadius: 1.25 }}>
      {children}
    </Paper>
  );
}
